import React, {Component} from 'react';

class ListLogByUserComponent extends Component {
    render() {
        return (
            <tr>
                <td>{ this.props.log.dateCreated }</td>
                <td>{ this.props.log.admin }</td>
                <td>{ this.props.log.service }</td>
            </tr>
        );
    }
}

export default ListLogByUserComponent;